var map = {
	"./Azure_datacenter.jpg": 4229,
	"./Azure_datacenter_edit.jpg": 8383,
	"./BU_Photonics.jpg": 1354,
	"./Cadence.png": 8734,
	"./Computer_Arch.jpg": 7854,
	"./Draper.png": 2797,
	"./Intel-FPGA.png": 4705,
	"./Intel-FPGA_small.png": 2449,
	"./MGHPCC.svg": 923,
	"./MITLL.png": 9399,
	"./MITLL_large.png": 1096,
	"./Machine_Learning.png": 8715,
	"./Mentor.png": 2503,
	"./Micron.png": 7322,
	"./Microsoft.png": 4074,
	"./Microsoft_small.png": 7769,
	"./NIH.png": 961,
	"./NIH_small.png": 6267,
	"./NSF.png": 321,
	"./NSF_small.png": 9024,
	"./Naval_Research_Laboratory_Logo.png": 7299,
	"./RedHat.png": 3081,
	"./RedHat_small.png": 5072,
	"./Synopsys.png": 1057,
	"./Xilinx.png": 3084
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8692;